import {i18n} from 'src/config/i18n.ts'
import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

export default async function ssoRedirect ({ to }) {
  // OpenIDM doesn't accept custom query params, we need to use the predefined "state"
  // In this case we need it for setting the branding
  const parseState = (state) => {
    try {
      return JSON.parse(state)
    } catch {
      return null
    }
  }
  const state = parseState(to.query?.state)
  // First, check for to.params.slink because it might be set during routing. Otherwise, it should be part of the state object
  const slink = to.params.slink || state.slink

  if (state && slink && !to.query.cancelSSOVerifyBranding) {
    return {
      name: 'sso-verify',
      query: {
        ...to.query,
        branding: state?.branding,
        goBackToParentWindow: state?.goBackToParentWindow,
        state: to.query.state,
        cancelSSOVerifyBranding: true
      },
      params: {
        ...to.params,
        slink
      },
      replace: true
    }
  }

  if (!slink || !to.query.code) {
    GlobalPrototypes.toastNotify({
      type: 'error',
      text: i18n.global.t('ui.connection_lost.check_internet')
    })
    if (!slink) {
      if (to.name === 'login-start') return
      return { name: 'login-start', replace: true }
    }
    if (to.name === 'login-sign-in') return
    return { name: 'login-sign-in', params: { slink: slink }, replace: true }
  }
}
